/**
 * MediaUploadSection
 *
 * Wrapper around the shared MediaUploader component that accepts both
 * audio and video files.  Reads/writes state via SubtitlesContext.
 */

import { memo } from 'react';
import { Play, Music } from 'lucide-react';
import { MediaUploader } from '@/components/common/MediaUploader';
import { useTranslation } from '@/hooks/useTranslation';
import { useSubtitles } from '../SubtitlesContext.context';
import type { MediaType } from '@/components/common/MediaUploader';

export const MediaUploadSection = memo(function MediaUploadSection() {
  const { t } = useTranslation();
  const { state, isUploading, isGenerating, handleMediaSelect, handleMediaRemove } = useSubtitles();
  const { mediaType, uploadProgress } = state;

  return (
    <div className="panel-glass">
      <h3 className="section-heading">
        {mediaType === 'audio' ? (
          <Music className="h-4 w-4 sm:h-5 sm:w-5 text-purple-400" />
        ) : (
          <Play className="h-4 w-4 sm:h-5 sm:w-5 text-purple-400" />
        )}
        <span>{t('subtitles.upload.title', { defaultValue: 'Upload Media File' })}</span>
      </h3>
      <MediaUploader
        accept={['video', 'audio']}
        onFileSelect={(file, type) => handleMediaSelect(file, type as MediaType)}
        onRemove={handleMediaRemove}
        disabled={isUploading || isGenerating}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
        dropzoneText={t('subtitles.upload.dropzone', {
          defaultValue: 'Drag and drop your video or audio file here',
        })}
        translationNamespace="subtitles"
      />
    </div>
  );
});
